const SOPT_CLASSIC_LEVEL_MIN = 0;
const SOPT_CLASSIC_LEVEL_MAX = 100;
const SOPT_ESTIMATED_AGE_MIN = 18;
const SOPT_ESTIMATED_AGE_MAX = 85;
const SOPT_EVALUATION_INITIAL_LEVEL = 37;
const SOPT_EVALUATION_INITIAL_AGE = 45;

const SOPT_CLASSIC_LEVEL_AGE_POINTS = Object.freeze([
    Object.freeze({ level: SOPT_CLASSIC_LEVEL_MIN, age: SOPT_ESTIMATED_AGE_MAX }),
    Object.freeze({ level: 20, age: 65 }),
    Object.freeze({ level: SOPT_EVALUATION_INITIAL_LEVEL, age: SOPT_EVALUATION_INITIAL_AGE }),
    Object.freeze({ level: 50, age: 35 }),
    Object.freeze({ level: 60, age: 20 }),
    Object.freeze({ level: 70, age: SOPT_ESTIMATED_AGE_MIN }),
    Object.freeze({ level: SOPT_CLASSIC_LEVEL_MAX, age: SOPT_ESTIMATED_AGE_MIN }),
]);

const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

const normalizeSoptClassicLevel = (level, fallback = SOPT_CLASSIC_LEVEL_MIN) => {
    const parsedLevel = Number(level);

    return clamp(
        Number.isFinite(parsedLevel) ? parsedLevel : fallback,
        SOPT_CLASSIC_LEVEL_MIN,
        SOPT_CLASSIC_LEVEL_MAX
    );
};

const getSoptEstimatedAgeForClassicLevel = (level) => {
    const safeLevel = normalizeSoptClassicLevel(level);

    for (let index = 0; index < SOPT_CLASSIC_LEVEL_AGE_POINTS.length - 1; index += 1) {
        const start = SOPT_CLASSIC_LEVEL_AGE_POINTS[index];
        const end = SOPT_CLASSIC_LEVEL_AGE_POINTS[index + 1];

        if (safeLevel >= start.level && safeLevel <= end.level) {
            const ratio = end.level === start.level
                ? 0
                : (safeLevel - start.level) / (end.level - start.level);

            return clamp(
                start.age + ((end.age - start.age) * ratio),
                SOPT_ESTIMATED_AGE_MIN,
                SOPT_ESTIMATED_AGE_MAX
            );
        }
    }

    return safeLevel >= SOPT_CLASSIC_LEVEL_MAX
        ? SOPT_ESTIMATED_AGE_MIN
        : SOPT_ESTIMATED_AGE_MAX;
};

const getSoptClassicLevelForEstimatedAge = (age) => {
    const parsedAge = Number(age);
    const safeAge = clamp(
        Number.isFinite(parsedAge) ? parsedAge : SOPT_EVALUATION_INITIAL_AGE,
        SOPT_ESTIMATED_AGE_MIN,
        SOPT_ESTIMATED_AGE_MAX
    );

    for (let index = 0; index < SOPT_CLASSIC_LEVEL_AGE_POINTS.length - 1; index += 1) {
        const start = SOPT_CLASSIC_LEVEL_AGE_POINTS[index];
        const end = SOPT_CLASSIC_LEVEL_AGE_POINTS[index + 1];
        const minAge = Math.min(start.age, end.age);
        const maxAge = Math.max(start.age, end.age);

        if (safeAge >= minAge && safeAge <= maxAge) {
            const ratio = end.age === start.age
                ? 0
                : (safeAge - start.age) / (end.age - start.age);

            return normalizeSoptClassicLevel(
                Math.round(start.level + ((end.level - start.level) * ratio))
            );
        }
    }

    return safeAge <= SOPT_ESTIMATED_AGE_MIN
        ? SOPT_CLASSIC_LEVEL_MAX
        : SOPT_CLASSIC_LEVEL_MIN;
};

const soptEstimatedAge = {
    SOPT_CLASSIC_LEVEL_AGE_POINTS,
    SOPT_CLASSIC_LEVEL_MAX,
    SOPT_CLASSIC_LEVEL_MIN,
    SOPT_ESTIMATED_AGE_MAX,
    SOPT_ESTIMATED_AGE_MIN,
    getSoptClassicLevelForEstimatedAge,
    getSoptEstimatedAgeForClassicLevel,
    normalizeSoptClassicLevel,
};

module.exports = soptEstimatedAge;
module.exports.default = soptEstimatedAge;
